import React from 'react'
import TransitionLink from 'gatsby-plugin-transition-link'
import gsap from 'gsap'

export default function Link({ children,...props }) {

    const exit = {
        trigger: ({ exit, node }) => gsap.fromTo(node, { y: 0 }, { y: 60, opacity: 0, duration: .85, ease: "power3.inOut" }),
        length: .85,
    }

    const entry = {
        trigger: ({ entry, node }) => {
            gsap.fromTo(node, { y: -60, opacity: 0 }, { y: 0, z: 0, duration: 1.2, delay: 0.1, ease: "power3.inOut" });
            gsap.to(node, { opacity: 1, duration: .85, delay: .25, ease: "power3.inOut" });
        },
        delay: .85
    }

    return (
        <TransitionLink entry={entry} exit={exit} {...props}>
            {children}
        </TransitionLink>
    )
}
